import React from 'react';
import PropTypes from 'prop-types';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';

/**
 * Send the GA event basis on widget id
 * @param {*} Object having dom event type, widget id and wu
 */
const sendGA = ({ eventtype, id, wu }) => {
  switch (id) {
    case 'creditscoreiframe':
      if (eventtype === 'click') {
        analyticsWrapper('ga4', {
          event: 'user_click',
          type: 'et_saver_widget',
          category: 'open',
        });
      } else if (eventtype === 'scrollInView') {
        analyticsWrapper('ga4', {
          event: 'user_shown',
          type: 'et_saver_widget',
        });
      }
      break;
    case 'covidwidget':
      if (eventtype === 'click') {
        sendGaThroughProps({
          data: {
            gaCategory: 'WAP-IN-NHP1',
            gaAction: 'CoronavirusSection_click',
            gaLabel: `${wu}`,
          },
        });
      }
      break;
    case 'topcovidwidget':
      if (eventtype === 'click') {
        sendGaThroughProps({
          data: {
            gaCategory: 'WAP-IN-NHP1',
            gaAction: 'CoronavirusWidget_click',
            gaLabel: `${wu}`,
          },
        });
      } else if (eventtype === 'scrollInView') {
        sendGaThroughProps({
          data: {
            gaCategory: 'WAP-IN-NHP1',
            gaAction: 'CoronavirusWidget-View',
            gaLabel: 'Scroll_CoronavirusWidget',
          },
        });
      }
      break;
    case 'wimbledoniframe':
      if (eventtype === 'click') {
        sendGaThroughProps({
          data: {
            gaCategory: 'Wimbeldon_Widget',
            gaAction: 'click',
            gaLabel: `${
              typeof window !== 'undefined' &&
              window.location &&
              window.location.href
                ? window.location.href
                : ''
            }`,
          },
        });
      } else if (eventtype === 'scrollInView') {
        sendGaThroughProps({
          data: {
            gaCategory: 'Wimbeldon_Widget',
            gaAction: 'seen',
            gaLabel: `${
              typeof window !== 'undefined' &&
              window.location &&
              window.location.href
                ? window.location.href
                : ''
            }`,
            nonInteraction: true,
          },
        });
      }
      break;

    default:
      break;
  }
};

const withIframeWdt = (WrappedComponent, props) => {
  const { id, wu } = props;
  const _sendGA = eventtype => sendGA({ eventtype, id, wu });
  return id === 'covidwidget' ||
    id === 'topcovidwidget' ||
    id === 'wimbledoniframe' ||
    id === 'creditscoreiframe' ? (
    <WrappedComponent sendGA={_sendGA} {...props} key={id} />
  ) : (
    <WrappedComponent {...props} key={id} />
  );
};

withIframeWdt.propTypes = {
  id: PropTypes.string,
  wu: PropTypes.string,
};

withIframeWdt.defaultProps = {
  wu: '',
  id: '',
};

export default withIframeWdt;
